<template>
  <div>
    <base-crud crudName="Atividades de Usuários" newText :table="table" :columns="columns" :options="options"
      :endPoint="endPoint" :enableAdd="false" :enableEdit="false" :enableDelete="false" :enableView="false"
      :dataForm="dataForm" :extra="extra"></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "userActivitiesTable",
      columns: [
        "id",
        "user_name",
        "action",
        "description",
        "model_type",
        "model_id",
        "ip_address",
        "created_at",
      ],
      tableData: [
        "id",
        "user_name",
        "action",
        "description",
        "model_type",
        "model_id",
        "ip_address",
        "created_at",
      ],
      options: {
        sortable: [
          "id",
          "user_name",
          "action",
          "model_type",
          "model_id",
          "ip_address",
          "created_at",
        ],
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "user_name",
          "action",
          "description",
          "model_type",
          "model_id",
          "ip_address",
          "created_at",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_name: "Usuário",
          action: "Ação",
          description: "Descrição",
          model_type: "Tipo",
          model_id: "ID do Registro",
          ip_address: "IP",
          created_at: "Data",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        templates: {
          action: function (h, row, index) {
            return row.action_label ? row.action_label : row.action;
          },
          model_type: function (h, row, index) {
            return row.model_type_label ? row.model_type_label : row.model_type;
          },
          created_at: function (h, row, index) {
            if (!row.created_at) return "";

            const [datePart, timePart] = row.created_at.split("T");

            const [year, month, day] = datePart.split("-");
            const [hour, minute, second] = timePart.split(":");

            return `${day}/${month}/${year} ${hour}:${minute}`;
          }
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      extra: [],
      endPoint: "user_activities/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        user_name: "user_name",
        action: "action",
        description: "description",
        model_type: "model_type",
        model_id: "model_id",
        ip_address: "ip_address",
        created_at: "created_at",
      };

      let filters = "orderByDesc=id&";

      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/UserActivity/Crud.vue